import { cn } from '../../client/cn';

const AVATAR_COLORS = [
  'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300',
  'bg-success-100 text-success-700 dark:bg-success-900/40 dark:text-success-300',
  'bg-info-100 text-info-700 dark:bg-info-900/40 dark:text-info-300',
  'bg-warning-100 text-warning-700 dark:bg-warning-900/40 dark:text-warning-300',
  'bg-secondary-100 text-secondary-700 dark:bg-secondary-900/40 dark:text-secondary-300',
] as const;

function getColorFromName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getInitial(name: string | null | undefined): string {
  if (!name) return '?';
  return name[0].toUpperCase();
}

const sizeClasses = {
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-7 w-7 text-xs',
  lg: 'h-14 w-14 text-xl',
} as const;

interface UserAvatarProps {
  username: string | null | undefined;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function UserAvatar({
  username,
  size = 'md',
  className,
}: UserAvatarProps) {
  const name = username || 'Anonymous';
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full font-semibold',
        sizeClasses[size],
        getColorFromName(name),
        className,
      )}
      aria-hidden="true"
    >
      {getInitial(name)}
    </div>
  );
}
